// extracted by mini-css-extract-plugin
module.exports = {"ecgLoader":"EcgLoaderSmall_ecgLoader__2EOgL","pulse":"EcgLoaderSmall_pulse__252HW","dash":"EcgLoaderSmall_dash__1bqlU"};